import { createContext, ReactNode, use } from 'react';

import Api from '../lib/api/Api';

interface ApiContextValue {
    api: Api;
}

export const ApiContext = createContext<ApiContextValue>({
    api: new Api(),
});

export function useApiContext() {
    const context = use(ApiContext);
    return context;
}

export function useApi() {
    const { api } = useApiContext();
    return api;
}

interface ApiContextProviderProps {
    client?: Api | null;
    children?: ReactNode;
}

export function ApiContextProvider({ client = null, children = null }: ApiContextProviderProps) {
    const value = {
        api: client,
    };

    return <ApiContext value={value}>{children}</ApiContext>;
}
